import Api from '../api'
import { captureFetchException, createButtonPlugin } from '../common/helpers'
import { showToast } from '../components/toast'

// noinspection JSUnusedGlobalSymbols
export default createButtonPlugin('game-notification', (element) => {
  const game_id = element.getAttribute('data-toggle-game-notify')
  const svgUse = element.querySelector('use')

  Api.post<{
    tracking: number
  }>({ url: 'game/toggle-notify', body: { game_id } })
    .then((response) => {
      let text = 'Уведомления включены'
      let icon = 'sg-new/bell'
      if (!response.tracking) {
        text = 'Уведомления отключены'
        icon = 'sg-new/bell-cross'
      }
      svgUse.setAttribute('href', `#${icon}`)
      showToast({
        type: 'success',
        text,
      })
      const event = new CustomEvent<{
        notify: number
      }>('changeGameNotify', {
        detail: {
          notify: response.tracking
        },
        bubbles: true,
      })
      element.dispatchEvent(event)
    })
    .catch((error) => {
      captureFetchException(error)
      showToast({
        type: 'error',
        text: 'Не удалось изменить статус уведомлений',
      })
    })
})
